import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {translate} from 'react-i18next';
import {DEFAULT_LANGUAGE, LANGUAGES} from '../../constants';
import Select from 'react-select';
import PropTypes from "prop-types";
import PickUpTimeLayout from "../../containers/PickUpTime";
import ReorderLayout from '../../containers/Reorder';
import ProfileMenuView from '../Customer/Profile/ProfileMenuView';
import RestaurantLayout from '../../containers/Restaurant';
import {getLanguagesFromUri, getUriWithLanguages} from "../../helpers";


class HeaderViewComponent extends Component {

  constructor(props) {
    super(props);
    this.startRestaurant = this.startRestaurant.bind(this);
  }

  changeLanguage(event) {
    const {i18n} = this.props;
    const lng = event.value;
    i18n.changeLanguage(lng);
    this.props.setLanguage(lng);
    const newPath = getUriWithLanguages(this.props.location.pathname, lng, this.props.restaurants);
    this.props.history.replace(decodeURIComponent(newPath));
  }

  startRestaurant() {
    const {selected, selectedRestaurant, startSelectedFetchRestaurant, endSelectedFetchRestaurant} = this.props;
    startSelectedFetchRestaurant();
    selectedRestaurant(selected.id).then(() => {
      endSelectedFetchRestaurant();
      const lng = this.props.language.defaultLanguage || DEFAULT_LANGUAGE;
      this.props.history.push(`/${lng}/${this.props.selected.name_for_url}/products/pizza`);
    });
  }

  render() {
    const {selected, t, user, location, exitCustomer, openAuthModal, language} = this.props;
    const {defaultLanguage} = language;
    let {pathname} = location;
    pathname = pathname.replace(/\/$/, '');
    const recap = pathname === '/recap';
    let lngFromUrl = getLanguagesFromUri(pathname, defaultLanguage);
    if (lngFromUrl === 'pity' || lngFromUrl === 'terms') {
      lngFromUrl = defaultLanguage;
    }
    const mainPage = pathname === '/' || pathname === `/${lngFromUrl}`;
    const productPage = !mainPage;
    let languages = [];
    let customer = user.toObject();
    Object.keys(LANGUAGES).forEach(key => {
      languages.push({
        value: key,
        label: LANGUAGES[key]
      })
    });
    return (
      <header className="app__header">
        <div className="app__wrapper">
          <div className="page-header">
            <Link to={`/${defaultLanguage}`} className="page-header__logo" title="Home">
            </Link>
            {(productPage || mainPage) &&
            <div className="page-header__location">
              <span className="icon icon-location">
              </span>
              <div className='page-header__select-wrapper'>
                <Select
                  name="form-takeAway"
                  clearable={false}
                  value='1'
                  className="Select--has-background"
                  options={[{value: 1, label: t('takeAway')}]}
                  searchable={false}
                />
              </div>
              <span>{t('for')}</span>
              <div className='page-header__select-wrapper page-header__select-wrapper--wide'>
                {recap ?
                  <div>{selected.name}</div>
                  :
                  <RestaurantLayout
                    classes='Select--has-background'
                  />
                }
              </div>
            </div>
            }
            {mainPage &&
              <div className="map-location-select">
                <div className="map-location-select__inner">
                  <div className='page-header__select-wrapper map-location-select__input'>
                    <RestaurantLayout
                      classes='Select--has-background'
                    />
                  </div>

                  <button
                    className="form__button map-location-select__btn"
                    onClick={this.startRestaurant}
                    disabled={!selected.id}
                  >{t('start')}</button>
                </div>

              </div>
            }
            {productPage &&
              <PickUpTimeLayout
                classNames='page-header__time'
              />
            }
            {productPage &&
            <div className="page-header__reorder">
              <ProfileMenuView
                customer={customer}
                exitCustomer={exitCustomer}
                openAuthModal={openAuthModal}
                selected={selected}
                language={language.defaultLanguage}
              />
              <ReorderLayout />
            </div>
            }
            {productPage &&
            <div className="page-header__language page-header__select-wrapper page-header__select-wrapper--language">
              <Select
                name="form-languages"
                clearable={false}
                value={defaultLanguage}
                options={languages}
                onChange={(e) => this.changeLanguage(e)}
                searchable={false}
              />
            </div>
            }
          </div>
        </div>

        {this.props.children}
      </header>
    );
  }
}

HeaderViewComponent.propTypes = {
  user: PropTypes.object,
  selected: PropTypes.object,
  exitCustomer: PropTypes.func,
  openAuthModal: PropTypes.func,
};


export default withRouter(translate('translations')(HeaderViewComponent));


// WEBPACK FOOTER //
// ./src/components/Header/HeaderView.js